export const REGISTRATION_INPUT_CHANGE = "registration_input_change";

export const REGISTRATION_INPUT_CLEAR = "registration_input_clear";

export const REGISTRATION_STEP1_DONE = "registration_step1_done";
export const REGISTRATION_STEP2_DONE = "registration_step2_done";
export const SET_VERIFICATION_QUESTIONS_STATUS = "set_verification_questions_status";
export const CORRECT_ANSWERS_IDENTYFLOW = "correct_answers_identyflow";
